import { IoChevronForwardOutline } from "react-icons/io5";
import { Link, useParams , useOutletContext } from "react-router";
import styled from "styled-components";

import ParameterEditor from "./ParameterEditor";
import ParameterGroup from "./ParameterGroup";
import ParameterTitle from "./ParameterTitle";
import { TAXONOMY_BASE } from "../../../../../constants";
import { CssSectionCard } from "../../../components/styles";

import type { ParameterOutletContext } from "../WithParameterInventory";

const StyledParameterDetail = styled.div`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 320px 1fr;
    gap: 20px;
    height: 100%;
    min-height: 0;
    overflow: hidden;

    .section-card {
        ${ CssSectionCard }
    }

    /* the info column grows past the card height; without this its last
       control is clipped by CssSectionCard's overflow: hidden */
    & > .section-card:first-of-type {
        overflow-y: auto;
    }

    .nav-breadcrumbs {
        align-items: center;
        display: flex;
        gap: 6px;
        font-size: 0.8rem;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #ebecf0;

        a {
            color: #6b778c;
            text-decoration: none;
            font-weight: 500;

            &:hover {
                color: #0052cc;
            }
        }

        svg {
            color: #a5adba;
            font-size: 0.75rem;
        }

        .current {
            color: #172b4d;
            font-weight: 600;
        }
    }
`;

export default function ParameterDetail() {
    const { parameterID } = useParams();
    const guard = useOutletContext<ParameterOutletContext>();

    return (
        <StyledParameterDetail>
            {/* Column 1: Info & Parameter Group */}
            <div className="section-card">
                <div className="nav-breadcrumbs">
                    <Link to={ TAXONOMY_BASE }>Home</Link>
                    <IoChevronForwardOutline />
                    <Link to={ `${ TAXONOMY_BASE }/Parameters` }>Parameters</Link>
                </div>
                <ParameterTitle
                    id={ parameterID }
                />
                <ParameterGroup
                    id={ parameterID }
                />
            </div>

            {/* Column 2: Parameter Editor */}
            <div className="section-card">
                <ParameterEditor
                    guard={ guard }
                    id={ parameterID }
                    key={ parameterID }
                />
            </div>
        </StyledParameterDetail>
    );
}
